module.exports = __webpack_public_path__ + "static/media/text-icon.7c62b5fc.svg";